import { useQuery } from '@apollo/client';
import { ICheckoutCart, ICheckoutNotification } from '@monofront/types';
import { GET_CHECKOUT_CART } from '@monofront/business/queries';
import { useCheckoutCartId } from '@monofront/business/contexts';
import CheckoutCartMachineState from './CheckoutCartMachineState';

interface ICheckoutCartQuery {
  getCheckoutCartWithRefresh: {
    cart: ICheckoutCart;
    notifications: [ICheckoutNotification];
  };
}

export const CheckoutCartMachineProvider = ({ children }) => {
  const [checkoutCartId] = useCheckoutCartId();

  const { data } = useQuery<ICheckoutCartQuery>(GET_CHECKOUT_CART, {
    variables: { tokenValue: checkoutCartId, refresh: false /*!isFromCart*/ },
    skip: !checkoutCartId,
    notifyOnNetworkStatusChange: true,
    ssr: false,
  });

  return (
    <CheckoutCartMachineState
      checkoutCart={data?.getCheckoutCartWithRefresh.cart ?? null}
    >
      {children}
    </CheckoutCartMachineState>
  );
};
